import BaseApi from '../../base/base'

export interface AiUsageSummary {
  totalInputTokens: number
  totalOutputTokens: number
  totalTokens: number
  totalMessages: number
  monthlyLimit: number | null
  usagePercentage: number
  limitExceeded: boolean
  alertLevel?: 'warning' | 'limit_reached' | null
  alertThresholdReached?: boolean
  monthStart?: string
  monthEnd?: string
  featureBreakdown?: AiFeatureBreakdown[]
  dailyBreakdown?: AiDailyBreakdown[]
  userBreakdown?: AiUserBreakdown[]
}

export interface AiFeatureBreakdown {
  featureType: string
  featureLabel: string
  inputTokens: number
  outputTokens: number
  totalTokens: number
  totalMessages: number
}

export interface AiDailyBreakdown {
  date: string
  inputTokens: number
  outputTokens: number
  totalTokens: number
  totalMessages: number
}

export interface AiUserBreakdown {
  userId: number
  userName: string
  userEmail: string
  inputTokens: number
  outputTokens: number
  totalTokens: number
  totalMessages: number
}

export default class AiUsageApi extends BaseApi {
  constructor() {
    super()
  }

  // examId names the exam being edited; the server derives and authorizes its school.
  async show(params: { examId?: number } = {}): Promise<AiUsageSummary> {
    this.path = '/admin/ai_usage'
    const response = await this.getRequest(params)
    return response.data
  }
}
